import React from "react";

const TireChangeModal = ({
  isTireChangeModalOpen,
  tyreDetails,
  tyreRimId,
  setTyreRimId,
  tyreHeightId,
  setTyreHeightId,
  tyreWidthId,
  setTyreWidthId,
  tyreTypeId,
  setTyreTypeId,
  tyreBrandId,
  setTyreBrandId,
  getAvailableTyres,
  isEdit,
  toggleSubCategories,
  setIsTireChangeModalOpen,
}) => {
  return (
    isTireChangeModalOpen && (
      <div
        className="modal fade show"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden={isTireChangeModalOpen ? "false" : "true"}
        style={{ display: "block" }}
      >
        <div className="modal-dialog orderDetails-modal" role="document">
          <div className="modal-content">
            <div className="modal-header orderDetails-modalHeader px-4">
              {isEdit ? (
                <i
                  className="fa-solid fa-circle-xmark fa-xl cursor"
                  onClick={() => setIsTireChangeModalOpen(false)}
                ></i>
              ) : (
                <i
                  onClick={toggleSubCategories}
                  className="fa-solid fa-chevron-left cursor"
                ></i>
              )}
              <div className="d-flex align-items-center mx-auto">
                <p className="modal-title orderDetails-modalTitle mx-3 fs-3 fw-semibold">
                  تغيير الكاوتش
                </p>
                <i className="fa-solid fa-rotate fa-xl text-muted"></i>
              </div>
            </div>
            <div className="modal-body orderDetails-modalBody p-3">
              {tyreDetails && (
                <>
                  <div className="text-end my-3">
                    <label htmlFor="">مقاس الكاوتش</label>
                    <div className="d-flex justify-content-between gap-2 my-2">
                      <select
                        className="form-select"
                        value={tyreRimId}
                        onChange={(e) => setTyreRimId(e.target.value)}
                      >
                        <option value="">القطر</option>
                        {tyreDetails.rim_diameters.map((rim) => (
                          <option key={rim.value} value={rim.value}>
                            {rim.value}
                          </option>
                        ))}
                      </select>
                      <select
                        className="form-select"
                        value={tyreHeightId}
                        onChange={(e) => setTyreHeightId(e.target.value)}
                      >
                        <option value="">الارتفاع</option>
                        {tyreDetails.heights.map((height) => (
                          <option key={height.value} value={height.value}>
                            {height.value}
                          </option>
                        ))}
                      </select>
                      <select
                        className="form-select"
                        value={tyreWidthId}
                        onChange={(e) => setTyreWidthId(e.target.value)}
                      >
                        <option value="">العرض</option>
                        {tyreDetails.widths.map((width) => (
                          <option key={width.value} value={width.value}>
                            {width.value}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="text-end my-3">
                    <p className="my-1">نوع الكاوتش</p>
                    <div className="d-flex justify-content-end gap-3">
                      {tyreDetails.types.map((type) => (
                        <div key={type.id}>
                          <label htmlFor={type.name} className="mx-2">
                            {type.name}
                          </label>
                          <input
                            type="checkbox"
                            value={tyreTypeId}
                            checked={tyreTypeId === type.id}
                            onChange={() => setTyreTypeId(type.id)}
                            className="my-0"
                            id={type.name}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="text-end my-3">
                    <label htmlFor="">ماركة التصنيع</label>
                    <select
                      className="form-select my-2"
                      value={tyreBrandId}
                      onChange={(e) => setTyreBrandId(parseInt(e.target.value))}
                    >
                      <option value="">اختر ماركه التصنيع</option>
                      {tyreDetails.brands.map((brand) => (
                        <option key={brand.id} value={brand.id}>
                          {brand.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer mx-auto">
              <button
                type="button"
                className="btn btn-dark px-5 fs-5"
                onClick={getAvailableTyres}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default TireChangeModal;
